import { useQuery, keepPreviousData, useMutation } from '@tanstack/react-query';
import { createVehicle, updateVehicle, getVehicle, getVehicleByPlate, getVehicleByFasecolda, getVehicleByBrandModelLine, getBrands, getLines } from '@features/vehicles/services/vehiclesService';

const BASE = 'vehicles';

export const vehiclesQueryKeys = {
    base: () => [BASE],
    detail: (id) => [BASE, 'detail', id],
    detailByData: (data) => [BASE, 'detailByData', data],
    brands: (data) => [BASE, 'brands', data],
    lines: (data) => [BASE, 'lines', data],
}

export const useGetVehicle = (id, { enabled = true } = {}) => {
    return useQuery({
        queryKey: vehiclesQueryKeys.detail(id),
        queryFn: () => getVehicle(id),
        enabled: enabled && !!id,
    });
};

export const useGetVehicleByPlate = (data, { enabled = true, ...options } = {}) => {
    return useQuery({
        queryKey: vehiclesQueryKeys.detailByData(data),
        placeholderData: keepPreviousData,
        queryFn: () => getVehicleByPlate(data),
        enabled: enabled && !!data.plate,
        ...options,
    });
};

export const useGetVehicleByFasecolda = (data, { enabled = true, ...options } = {}) => {
    return useQuery({
        queryKey: vehiclesQueryKeys.detailByData(data),
        placeholderData: keepPreviousData,
        queryFn: () => getVehicleByFasecolda(data),
        enabled: enabled && !!data?.fasecoldaCode,
        ...options,
    });
};

export const useGetVehicleByBrandModelLine = (data, { enabled = true, ...options } = {}) => {
    return useQuery({
        queryKey: vehiclesQueryKeys.detailByData(data),
        placeholderData: keepPreviousData,
        queryFn: () => getVehicleByBrandModelLine(data),
        enabled: enabled && !!data?.brand && !!data?.model && !!data?.line,
        ...options,
    });
};

export const useGetBrands = (data, { enabled = true } = {}) => {
    return useQuery({
        queryKey: vehiclesQueryKeys.brands(data),
        placeholderData: keepPreviousData,
        queryFn: () => getBrands(data),
        enabled: enabled && !!data,
    });
};

export const useGetLines = (data, { enabled = true } = {}) => {
    return useQuery({
        queryKey: vehiclesQueryKeys.lines(data),
        placeholderData: keepPreviousData,
        queryFn: () => getLines(data),
        enabled: enabled && !!data.brand && !!data.model,
    });
};

export const useCreateVehicle = () => {
    return useMutation({
        mutationFn: (data) => createVehicle(data),
    });
};

export const useUpdateVehicle = () => {
    return useMutation({
        mutationFn: ({ id, data }) => updateVehicle(id, data),
    });
};
